import Vue from 'vue'
import clarity from '@microsoft/clarity'

// Initialize Microsoft Clarity only in production
if (window.config.production) {
  clarity.init('tn5dmco6vq')
}

// Set user ID function
Vue.prototype.$setClarityUserId = (userId) => {
  if (userId) {
    try {
      window.clarity("identify", userId.toString(), undefined, undefined, userId.toString())
    } catch (error) {
      captureException(error)
    }
  }
}

// Export clarity instance for direct use if needed
export { clarity }
